import script from "./PayoutReviewModal.vue?vue&type=script&setup=true&lang=js"
export * from "./PayoutReviewModal.vue?vue&type=script&setup=true&lang=js"

import "./PayoutReviewModal.vue?vue&type=style&index=0&id=e7a46452&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e7a46452"]])

export default __exports__